

const Header = () => {


    return (
        <header className="wrapper">
            <h1>Welcome to the record label search</h1>
            <h3>Record labels are a great way to find new music. Unfortunately alot of databases don't have label data. So I found one that does and it helps you find a label and see (some) the releases by that label, enjoy!</h3>
        </header>
    )

}

export default Header;